import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateConverterService {

  constructor() { }

  //Cuando en la fecha se guarda como: 31/12/2000 00:00:00
  convertUtcToLocalDate(dateString: string | Date): Date {
    const utcDate = new Date(dateString);
    return new Date(
      utcDate.getUTCFullYear(),
      utcDate.getUTCMonth(),
      utcDate.getUTCDate()
    );
  }

  //Cuando la fecha se guarda o se actualiza con horas: 31/12/2000 23:59:59 u otra hora
  //Se usa este metodo para que preserve el dia y no se cambie al dia siguiente
  convertDatePreserveDay(dateString: string | Date): Date {
    const date = new Date(dateString);
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );
  }

  convertUtcToLocalDateFull(dateInput: string | Date): Date {
    if (dateInput === null || dateInput === undefined) {
      return null as any;
    }
    let utcString: string;
    if (dateInput instanceof Date) {
      utcString = dateInput.toISOString();
    } else if (typeof dateInput === 'string') {
      if (dateInput === '') {
        return null as any;
      }
      utcString = dateInput.endsWith('Z') ? dateInput : `${dateInput}Z`;
    } else {
      return null as any;
    }
    const utcDate = new Date(utcString);
    if (isNaN(utcDate.getTime())) {
      return null as any;
    }
    return new Date(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      utcDate.getHours(),
      utcDate.getMinutes(),
      utcDate.getSeconds(),
    );
  }
}
